export const MINIMAL_SEARCH_STRING_LENGTH = 2;
